'use client';

import { I18nextProvider } from 'react-i18next';

import i18n from '@/translationsConfig/i18n';

type Props = {
  children: React.ReactNode;
};

const TranslationsProvider = ({ children }: Props) => {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};

export default TranslationsProvider;
